import { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { getCustomerById, updateCustomer } from '../../api/customers';
import { getResponseById, updateResponse } from '../../api/responses';
import {
  getScoreFromResponse,
  getAgeFromResponse,
  getWeightFromResponse,
  getHeightFromResponse,
  getBMIFromResponse,
  getGenderFromResponse,
} from '../../helpers/response';

import { ReactComponent as ArrowRightSVG } from '../../icons/arrow-right.svg';

import CustomerSelect from '../../components/select/customer_select';

const ResponseEdit = () => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const { id } = useParams();
  const history = useHistory();

  const fetchResponseData = useCallback(async () => {
    setLoading(true);
    const data = await getResponseById(id);

    setResponse({
      ...data,
      customer: {
        ...data.customer,
        value: `${data.customer.firstName} ${data.customer.lastName}`,
        label: `${data.customer.firstName} ${data.customer.lastName}`,
      },
    });
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchResponseData();
  }, [fetchResponseData]);

  const onCustomerSelect = (option) => {
    setResponse({ ...response, customer: option });
  };

  const onSubmit = async () => {
    setLoading(true);

    const customer = await getCustomerById(response.customer.id);

    if (customer && (!customer.responses || customer.responses.length === 0)) {
      await updateCustomer(customer.id, {
        score: getScoreFromResponse(response),
        weight: getWeightFromResponse(response),
        height: getHeightFromResponse(response),
        bmi: getBMIFromResponse(response),
        age: getAgeFromResponse(response),
        gender: getGenderFromResponse(response),
      });
    }

    await updateResponse(id, response);

    history.goBack();
  };

  if (loading || !response)
    return (
      <main className="th-main">
        <section className="th-canvas"></section>
      </main>
    );

  return (
    <>
      <main className="th-main">
        <section className="th-canvas">
          <header className="th-canvas-header post-header">
            <h2 className="th-canvas-title">
              <span className="pointer" onClick={() => history.goBack()}>
                Go Back
              </span>
              <span>
                <ArrowRightSVG />
              </span>
              {response.name}
            </h2>

            <section className="view-actions">
              <button
                className="btn-green"
                data-cy="submit"
                onClick={() => onSubmit()}
              >
                <span>Save</span>
              </button>
            </section>
          </header>
          <section className="view-container">
            <h4 className="midlightgrey f-small fw5 ttu mt15">Customer</h4>
            <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column">
              <div className="w-100 flex flex-column">
                <div className="w-100 flex flex-row items-start justify-between margin-between">
                  <CustomerSelect
                    className="customer-select"
                    valid={true}
                    label="Customer*"
                    value={response.customer}
                    onChange={(selectedOption) =>
                      onCustomerSelect(selectedOption)
                    }
                  />
                </div>
              </div>
            </div>
          </section>
        </section>
      </main>
    </>
  );
};

export default ResponseEdit;
